// jumboClient's own stringifier (`getValueInString`) does `if (!value)
// return ''`, which silently drops `false`/`0` (not just objects/arrays) -
// so every feature_meta value must be pre-converted to a non-empty string
// representation here, not left for that helper to coerce.
const toJumboMetaValue = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const stringifyFeatureMeta = (meta) =>
  Object.fromEntries(
    Object.entries(meta).map(([key, value]) => [key, toJumboMetaValue(value)]),
  );

export const getBrowser = () => {
  let browser = '';
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf('Chrome') !== -1) {
    browser = 'Chrome';
  } else if (userAgent.indexOf('Firefox') !== -1) {
    browser = 'Firefox';
  } else if (userAgent.indexOf('Safari') !== -1) {
    browser = 'Safari';
  } else if (userAgent.indexOf('Edge') !== -1) {
    browser = 'Edge';
  } else if (
    userAgent.indexOf('MSIE') !== -1 ||
    userAgent.indexOf('rv:') !== -1
  ) {
    browser = 'Internet Explorer';
  } else {
    browser = 'Unknown';
  }
  return browser;
};
